import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueTheMask from "vue-the-mask";
import VuetifyConfirm from "vuetify-confirm";
import app from "./services/auth_handler";
import VCalendar from "v-calendar";
import VueMeta from "vue-meta";
import toBrDate from "./utils/toBrDate";
import formatCpf from "./utils/formatCpf";
import isInSchedule from "./utils/isInSchedule";
import isInScheduleField from "./utils/isInScheduleField";
import formataTelefone from "./utils/formataTelefone";
import returnAppealType from "./utils/returnAppealType";
import validateCpf from "./utils/validateCpf";
import cleanString from "./utils/cleanString";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import isCops from "./utils/isCops";
import isBoardmember from "./utils/isBoardmember";
import courseHandler from "./utils/courseHandler";
import toDate from "./utils/toDate";
import Print from "vue-print-nb";
import math from "./utils/fazConta/math";
import calculate from "./utils/fazConta/calculate";
import mathStringFunction from "./utils/fazConta/mathStringFunction";
import selectType from "./utils/tipoEdital"

Vue.component("DatePicker", DatePicker);
Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);
Vue.use(VuetifyConfirm, { vuetify });
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});
Vue.use(VueTheMask);
Vue.use(VCalendar, {
  componentPrefix: "vc", // Use <vc-calendar /> instead of <v-calendar />
});
Vue.use(Print);
Vue.config.productionTip = false;
Vue.prototype.$toBrDate = toBrDate;
Vue.prototype.$formatCpf = formatCpf;
Vue.prototype.$formataTelefone = formataTelefone;
Vue.prototype.$returnAppealType = returnAppealType;
Vue.prototype.$isInSchedule = isInSchedule;
Vue.prototype.$isInScheduleField = isInScheduleField;
Vue.prototype.$validateCpf = validateCpf;
Vue.prototype.$cleanString = cleanString;
Vue.prototype.$isCops = isCops;
Vue.prototype.$isBoardmember = isBoardmember;
Vue.prototype.$courseHandler = courseHandler;
Vue.prototype.$toDate = toDate;
Vue.prototype.$math = math
Vue.prototype.$calculate = calculate
Vue.prototype.$mathStringFunction = mathStringFunction
Vue.prototype.$selectType = selectType

app
  .reauthenticate()
  .then(() => {
    new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App),
    }).$mount("#app");
  })
  .catch(() => {
    new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App),
    }).$mount("#app");
  });
